<template>
<v-card class="border">
  <div class="tituloBox p-l-15">
    <div class="bg-red barraTitulo"></div>
    <h1 class="text-default font-size-18"><strong>Recuperar</strong> Acesso</h1>
  </div>
  <v-form v-model="valid" lazy-validation ref="formRecuperarSenha">
    <v-flex xs12 md6>
          <v-switch
            v-model="flgEstrangeiro"
            label="Sou Estrangeiro"
            color="info"              
            hide-details
          ></v-switch>
    </v-flex>
    <v-layout row>    
      <v-flex xs12 v-if="flgEstrangeiro===true">             
        <v-text-field  v-if="flgEstrangeiro===true" v-model="recuperar" v-mask="maskCpfCnpj" label="Registro/Documento de Identificação *" required></v-text-field>
      </v-flex>
      <v-flex xs12 v-if="flgEstrangeiro===false">        
        <v-text-field v-if="flgEstrangeiro===false" v-model="recuperar" @input="toUpperCase" label="CNPJ ou CPF *" v-mask="maskCpfCnpj" :rules="validacao.cpfCnpj" required></v-text-field>        
      </v-flex>
      
    </v-layout>
    <v-layout row>
      <v-flex xs12 p-b-15 p-t-13>
        <v-btn large color="info" @click="recuperarSenha()">Recuperar Senha</v-btn>
      </v-flex>
      <v-flex xs6 p-b-15 p-t-13>
        <v-btn large color="success" @click="recuperarEmail()">Recuperar E-mail</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
  <v-form v-model="valid" lazy-validation ref="formAlterarSenha">
    <v-dialog v-model="dialog" persistent width="90%">
      <v-card>
        <v-card-title class="headline grey lighten-2">Nova senha</v-card-title>
        <v-layout row>
          <v-flex xs12 sm6>
            <v-text-field type="password" v-model="alterar.senha" :label="$t('label.senha')+' *'" :rules="validacao.validAlphaNumericCaracter" :hint="$t('messages.validacao.alphaNumericCaracter')" persistent-hint required></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field type="password" v-model="repitaSenha" :label="$t('label.repitaSenha')+' *'" :rules="[validaSenhaIguais() || msgRepitaSenha]" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex xs3 sm3>
            <v-btn color="warning" @click="dialog = false">Cancelar</v-btn>
          </v-flex>
          <v-flex xs3 sm3>
            <v-btn color="info" @click="alterarSenha()">Confirmar</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
  <v-dialog v-model="dialogPopup" max-width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">Recuperação de E-mail</v-card-title>
      <v-card-text>
        Para alterar o e-mail registrado em seu cadastro no CAF Digital, envie um e-mail para 
        <strong>cadastrodefornecedores@saeb.ba.gov.br</strong> com um documento em papel timbrado, assinado por um sócio ou representante legal da empresa, solicitando a modificação.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click="dialogPopup = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmaEmail" max-width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">Recuperação de E-mail</v-card-title>
      <v-card-text>
        <div>Selecione um e-mail adicional para receber o código de verificação:</div>
        <v-radio-group v-model="emailSelecionado">
          <v-radio
            v-for="(email, idx) in emailsAdicionais"
            :key="idx"
            :label="mascararEmail(email)"
            :value="email"
          ></v-radio>
        </v-radio-group>
      </v-card-text>
      
      <v-card-actions style="justify-content: space-between;">
        <v-btn
          color="warning"
          class="white--text"
          :style="{ width: '238px', height: '38px', fontWeight: 'bold', fontSize: '16px' }"
          @click="dialogConfirmaEmail = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          class="white--text"
          :disabled="!emailSelecionado"
          :style="{ width: '238px', height: '38px', fontWeight: 'bold', fontSize: '16px' }"
          @click="enviarCodigoParaEmail"
        >
          Confirmar
        </v-btn>
      </v-card-actions>


    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmaCelular" max-width="655" content-class="custom-dialog">
    <v-card class="elevation-5">
      <!-- Cabeçalho Estilizado -->
      <v-card-title class="headline primary white--text pa-3">
        <v-icon>mdi-cellphone-message</v-icon>
        <span style="margin-left: -0.1rem;">Recuperação de E-mail</span>
      </v-card-title>

      <!-- Corpo do Pop-up -->
      <v-card-text class="pa-6">
        <div class="text-body-1 mb-1 font-weight-bold">
          Confirme abaixo o número de celular:
        </div>

        <!-- Campo de Celular com Formatação -->
        <v-text-field
          v-model="celularDigitado"
          label="Nº do Celular"
          :rules="[validaCelular]"
          v-mask="'+## (##) #####-####'"
          outlined
          dense
          persistent-hint
          hint="Formato: +55 (00) 00000-0000"
          class="mb-2"
        ></v-text-field>

        <!-- Mensagem de Celular Cadastrado -->
        <div v-if="celularCadastrado && mascararCelular(celularCadastrado)" class="text-caption grey--text text--darken-2" style="font-size: 0.75rem; margin-left: -0.2rem;">
          <v-icon small color="green darken-2">mdi-check-circle</v-icon>
          Número cadastrado: <strong>{{ mascararCelular(celularCadastrado) }}</strong>
        </div>
        
        <!-- Frase adicional -->
        <div class="grey--text text--darken-1 mt-2" style="font-size: 0.75rem;">
          O número de celular informado deve ser o mesmo registrado em seu cadastro no CAF Digital.
        </div>

        <!-- Mensagem de Erro -->
        <div v-if="celularIncorreto" class="text-caption red--text mt-2">
          <v-icon small color="red">mdi-alert-circle</v-icon>
          O número informado não corresponde ao cadastrado
        </div>
      </v-card-text>

      <!-- Ações (Botões) -->
      <v-card-actions class="pa-3">
        <v-btn
          outline 
          color="red" 
          text 
          @click="naoTenhoAcesso"
          class="text-capitalize"
          style="width: 22.2rem; height: 2rem; color: red; border: 2px solid red; font-size: 0.7rem;"
        >
          <v-icon small>mdi-cellphone-off</v-icon>
          NÃO POSSUO ACESSO A ESTE CELULAR
        </v-btn>
        
        <v-spacer></v-spacer>
        
        <v-btn
          class="white--text" 
          color="orange darken-1" 
          text 
          @click="dialogConfirmaCelular = false"
          style="width: 11rem; height: 2rem; font-size: 11px"
        >
          Cancelar
        </v-btn>
        
        <v-btn 
          color="primary" 
          depressed 
          @click="confirmarCelular"
          class="ml-2"
          style="width: 10rem; height: 2rem; font-size: 12px;"
        >
          <v-icon small>mdi-check</v-icon>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>
</template>

<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import loginService from "../../../services/loginService";
export default {
  name: "recuperarSenhaForm",
  mixins: [util],
  data() {//Declaracao de variaveis
    return {
      valid: true,
      alterar: {
        senha: ""
      },
      repitaSenha: "",
      recuperar: null,
      recuperarEstrangeiro: null,
      flgEstrangeiro: false,
      dialog: false,
      dialogPopup: false, // Controle do pop-up
      dialogConfirmaCelular: false,
      celularDigitado: "+55 ",
      celularCadastrado: null,
      celularIncorreto: false,
      emailsAdicionais: [],
      dialogConfirmaEmail: false,
      emailSelecionado: null,
    };
  },
  computed:{
    maskCpfCnpj() {
      let str = "";
      let i = 0;
      for ( ; i < 14; i++) {
        str += "X";
      }
      return this.flgEstrangeiro
        ? [str]
        : ["XXX.XXX.XXX-XX", "XX.XXX.XXX/XXXX-##"];
    }
  },
  methods: {//Declaracao de todos os metodos
  toUpperCase(value) {
      if (value) {
       this.recuperar = value.toUpperCase();
      }
    },
    // Método para abrir o modal de senha
    validaSenhaIguais() {
      if (this.alterar.senha !== this.repitaSenha) {
        if (!this.repitaSenha) {
          this.msgRepitaSenha = this.$t("messages.validacao.campoObrigatorio")
        } else {
          this.msgRepitaSenha = this.$t("messages.validacao.senhasDiferentes")
        }
        return false
      }
      return true;
    },
    // Método para abrir o modal de senha
    abrirModalSenha() {
      if(this.$route.query.codAtivacao && this.$route.query.cgc){
        let model = {
            num_cgc_fornecedor: this.$route.query.cgc,
            cod_Ativacao: this.$route.query.codAtivacao,
            id: 0
          }
        loginService.validarcodativacao(model).then(response => { /*resposta do servico*/

            this.$store.commit("setToken", null);
            this.$store.commit("setTokenRefresh", null);

          this.$removePreload(); /*Ocultar o PreLoad*/
          this.dialog = true;
        }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
      }
    },
    // Método para alterar a senha
    alterarSenha() {
      if (this.$refs.formAlterarSenha.validate() && this.$route.query.cgc) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        let model = {
            Num_cgc_fornecedor: this.$route.query.cgc,
            Senha: this.alterar.senha
          }
        loginService.alterarsenha(model).then(response => { /*resposta do servico*/
          this.$toasted.success(response.data);
          this.dialog = false;
            this.$store.commit("setToken", null);
            this.$store.commit("setTokenRefresh", null);
          this.$router.push("/");
          this.$removePreload(); /*Ocultar o PreLoad*/
        }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
      }
    },
    // Método para recuperar senha
    recuperarSenha(){
      if (this.$refs.formRecuperarSenha.validate()) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        var cgc_fornecedor = "";
        if(this.flgEstrangeiro){
          cgc_fornecedor = this.recuperar;
        }else{
          cgc_fornecedor = this.recuperar.replace(/[^A-Z0-9]/gi,"");
        }
        let model = {
          Num_cgc_fornecedor: cgc_fornecedor,
          Senha: ''
        }
        loginService.recuperarsenha(model).then(response => { /*resposta do servico*/
          this.$toasted.success(response.data);
          this.$store.commit("setToken", "");
          this.$router.push("/");
          this.$removePreload(); /*Ocultar o PreLoad*/
        }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
      }
    },
    // Método para recuperar e-mail
    recuperarEmail() {
      if (this.$refs.formRecuperarSenha.validate()) {
        this.$mostrarPreload();

        var cgc_fornecedor = this.flgEstrangeiro
          ? this.recuperar
          : (this.recuperar || '').replace(/[^A-Z0-9]/gi, '').toUpperCase();

        let model = { NumCgcFornecedor: cgc_fornecedor };

        // NOVO FLUXO: Buscar e-mails adicionais
        loginService.consultarEmailsAdicionais(model).then(response => {
          this.$removePreload();

          if (response.data && response.data.emailsAdicionais && response.data.emailsAdicionais.length > 0) {
            // Exibir pop-up para seleção do e-mail adicional e envio do código
            this.emailsAdicionais = response.data.emailsAdicionais;
            this.dialogConfirmaEmail = true;
          } else {
            // Exibir pop-up padrão (imagem 2)
            this.mostrarPopup();
          }
        }).catch(error => {
          this.$removePreload();
          this.mostrarPopup();
        });
      }
    },
    // Novo método para exibir o pop-up
    mostrarPopup() {
      this.dialogPopup = true;
    },
    // Validação de celular
    validaCelular(value) {
      // Regex para validar números no formato internacional (+DDI seguido de 9 a 13 dígitos)
      const regex = /^\+\d{1,3} \d{9,13}$/; // Ex.: +55 71999999999
      return regex.test(value) || "Formato de celular inválido";
    },

    // Método para confirmar o celular
    confirmarCelular() {
      // Remove formatação para comparação
      const celularDigitadoLimpo = this.celularDigitado.replace(/[\s-]/g, '');
      const celularCadastradoLimpo = this.celularCadastrado.replace(/[\s-]/g, '');
      
      if (celularDigitadoLimpo === celularCadastradoLimpo) {
        // Celular confirmado - aqui você implementaria o envio de SMS com código
        this.$toasted.success("Celular confirmado com sucesso!");
        this.dialogConfirmaCelular = false;
        // Aqui implementaria a próxima etapa (envio de SMS, etc.)
      } else {
        // Celular não confere
        this.celularIncorreto = true;
      }
    },

    mascararEmail(email) {
      if (!email) return "";
      const [user, domain] = email.split("@");
      if (!user || !domain) return email;
      return user[0] + "***@" + domain;
    },
    enviarCodigoParaEmail() {
      // Aqui, chamada para o backend enviar código para o e-mail selecionado
    
      let model = {
            CGC:  this.recuperar.replace(/[^A-Z0-9]/gi,""),
            email: this.emailSelecionado,
           
          }
          console.log(model);
      loginService.enviaEmailRecuperacao(model).then(response => { /*resposta do servico*/
     
      if(response.data == true){
        this.$toasted.success("Código enviado para " + this.mascararEmail(this.emailSelecionado));
        this.dialogConfirmaEmail = false;
      }
      else{
        this.$toasted.error("Erro ao enviar email para:  " + this.mascararEmail(this.emailSelecionado));
        this.dialogConfirmaEmail = false;
      }
          }).catch(() =>{
          this.$removePreload(); /*Ocultar o PreLoad*/
          })

      // Exibir próximo passo, se houver
    },

    // Método quando o usuário não tem acesso ao celular
    naoTenhoAcesso() {
      this.dialogConfirmaCelular = false;
      this.mostrarPopup(); // Mostra o pop-up original com instruções para contato
    },
    // Método para mascarar número de celular
    mascararCelular(celular) {
      if (!celular) return ""; // Retorna vazio se o celular não existir

      const celularLimpo = celular.replace(/[^\d]+/g, ""); // Remove caracteres não numéricos

      if (celularLimpo.length < 10) return celular; // Retorna o número original se for muito curto

      const ddi = celularLimpo.slice(0, 2); // DDI (ex.: +55)
      const ddd = celularLimpo.slice(2, 4); // DDD (ex.: 71)
      const prefixo = celularLimpo.slice(4, 6); // Prefixo inicial (ex.: 99)
      const oculto = "***-**"; // Parte oculta
      const sufixo = celularLimpo.slice(-2); // Últimos dois dígitos (ex.: 52)

      return `+${ddi} (${ddd}) ${prefixo}${oculto}${sufixo}`; // Retorna formatado
    },
  },
  beforeMount(){
    this.abrirModalSenha()
  }
};
</script>
